
export const getRequestNeededStatus = (getState, isExpert) => {
  
  const com = getState().common.comission
  const reqUserId = getState().common.currentRequest.user_id
  const comIncludesReqUser = com.list?.map(({MID}) => MID).includes(reqUserId)

  const comissionListLength = Array.from(new Set(com.list?.filter(i => !i.absent).map(({MID}) => MID) || [])).length
  const listLength = comIncludesReqUser ? comissionListLength - 1 : comissionListLength
  const comissionValuesLength = Array.from(new Set(com.values?.map(({mid}) => mid) || [])).length

  const statusNeedUpgrade = listLength <= comissionValuesLength 

  if (isExpert) return statusNeedUpgrade ? (approved(getState) ? 6 : 7) : 3;
  return statusNeedUpgrade ? 3 : 2
} 


const approved = (getState) => {
  const { requestParts, currentRequest } = getState().common
  const haveAward = currentRequest.awards?.find(({status}) => !!status)
  const simpleApproved = currentRequest.simple_cert && haveAward
  const pointsSum = requestParts.reduce((sum, part) => sum + (parseInt(part.points) || 0), 0)
  const neededPoints = currentRequest.point
  const approved = currentRequest.simple_cert ? simpleApproved : pointsSum >= neededPoints 
  return approved
}